
import { useState, useEffect, useRef, useContext, createContext } from "react";
import { useNavigate } from "react-router-dom";

import { SubjectSelector, SubjectTypeSelector, ProgramSelector, FeatureTypeSelector } from "@Beasted1010/pivotal-wisdom";
import { fetchSubjectData, fetchProgramFeatureData, fetchAllFeaturesWithProgressForProgram } from "../utilities/server-fetch";

import { LessonsContextProvider } from "./LessonsContext";

import { CourseContextProvider } from "./CourseContext";
import { DeepDivesContextProvider } from "./DeepDivesContext";

import { useSubjectsMetadata } from "./SubjectsMetadataContext";

import { useUser } from "./UserContext";

import { toKebabCase } from "../utilities/helpers";



export {
  SubjectContextProvider,
  useSubject, useSubjectUpdate
};


const SubjectContext = createContext<any>( null ); // TODO: Properly fill out
const SubjectUpdateContext = createContext<any>( null );


function useSubject() {
  return useContext( SubjectContext );
}

function useSubjectUpdate() {
  return useContext( SubjectUpdateContext );
}






type SubjectContextProps = {
  children?: JSX.Element | JSX.Element[];
  subjectType: SubjectTypeSelector;
  subjectSelector: SubjectSelector;
  programSelector: ProgramSelector;
}


// TODO: Rename to SubjectContext ??? - But it does only have subjectData out of necessity to get programData
function SubjectContextProvider( {subjectType, subjectSelector, programSelector, children}: SubjectContextProps ) {
  // Provider handles...

  // ... Creating State
  const navigate = useNavigate();

  const [loading, setLoading] = useState( true );

  const [selectedSubjectType, setSelectedSubjectType] = useState<SubjectTypeSelector>( subjectType );

  const [selectedSubject, setSelectedSubject] = useState<SubjectSelector>( subjectSelector );
  const [selectedProgram, setSelectedProgram] = useState<ProgramSelector>( programSelector );
  //const [selectedFeature, setSelectedFeature] = useState<FeatureTypeSelector>( featureSelector );

  // TODO ---- Do I really want this data retrieved/stored like this? Will WrappedComponents use?
  // TODO: Fetch Subject Data -- From SERVER instead of Mock in /data Dir
  // TODO: Determine EXACTLY what need, and see if can get ri dof some (i.e. derive others, like featureData, from what's already there)
  const [subjectData, setSubjectData] = useState<ISubject | undefined>( undefined );
  const [programData, setProgramData] = useState<IProgram | undefined>( undefined );
  const [featuresData, setFeaturesData] = useState<IFeature[] | undefined>( undefined );

  //const [featureContent, setFeatureContent] = useState<ContentType>( null );

  const { foundationSubjectsMetadata, specialtySubjectsMetadata } = useSubjectsMetadata();

  //const { user } = useUser();

  // ... Updating State
  useEffect( () => {
    setSelectedSubject( subjectSelector );
    setSelectedProgram( programSelector );

    const abortController = new AbortController();
    async function updateData() {

      if( foundationSubjectsMetadata == null || specialtySubjectsMetadata == null ) return;

      let newSubjectData;
      switch( subjectType ) {
        case SubjectTypeSelector.FOUNDATION: {
          // TODO: Consider better way (so not going thorugh Subjects one by one via ".find" -- Consider converting to Object or Map of some sort, but need update Ribbon to use appropriately)
          newSubjectData = foundationSubjectsMetadata.find( (subjectMetadata: ISubjectMetadata) => {
            return subjectMetadata.selector == subjectSelector;
          });

          break;
        }

        case SubjectTypeSelector.SPECIALTY: {
          // TODO: Consider better way (so not going thorugh Subjects one by one via ".find" -- Consider converting to Object or Map of some sort, but need update Ribbon to use appropriately)
          newSubjectData = specialtySubjectsMetadata.find( (subjectMetadata: ISubjectMetadata) => {
            return subjectMetadata.selector == subjectSelector;
          });

          break;
        }

        default: {
          // TODO: ERROR Handle
          console.error(`Unknown Subject Type: ${subjectType}`);
        }
      }

      setSubjectData( newSubjectData );


      const newProgramData = newSubjectData?.programs.find( (program: IProgram) => {
        return program.selector == programSelector;
      });
      setProgramData( newProgramData );


      setLoading( false );
    }

    updateData();

    return () => {
      abortController.abort();
    }
    // TODO: Will "Loading" as part of Dependency Array cause repeated renders?
  }, [foundationSubjectsMetadata, specialtySubjectsMetadata, subjectType, subjectSelector, programSelector, loading]);

  
  const selectProgram = ( programSelected: ProgramSelector ) => {
    setSelectedProgram( programSelected );

    // TODO: Currently just blindly adding toKebabCase to get consistency with URL -- Consider more efficient way to handle this or at least place earlier to have variable itself already be in Kebab Case
    navigate( `/content/${toKebabCase(subjectType)}/${toKebabCase(subjectSelector)}/${toKebabCase(programSelected)}` );
  }


  // ... Persisting State down into Children
  return (
    <SubjectContext.Provider value={ {subjectData, programData, featuresData, selectedSubjectType, selectedSubject, selectedProgram} } >
      <SubjectUpdateContext.Provider value={ {selectProgram} } >

        {
          loading ?
            <h1>Loading...</h1>
          :
            children
        }

      </SubjectUpdateContext.Provider>
    </SubjectContext.Provider>
  )
}


// ================================= HELPERS =================================





/* */
